import { LinearProgress } from "@material-ui/core"
import PropTypes from "prop-types"
import { useContext } from "react"
import ClientsContext, { ClientsContainer } from "~/contexts/Clients"
import Page from "~/pages/Page"
import Router from "~/router"

import usePermissionsRedirect from "~/hooks/usePermissionsRedirect"

const Clients = ({ routes = [], ...rest }) => {
  usePermissionsRedirect("/learning-paths", "clients")

  return (
    <Page>
      <ClientsContainer>
        <ClientsWrapper>
          <Router routes={routes} {...rest} />
        </ClientsWrapper>
      </ClientsContainer>
    </Page>
  )
}

Clients.propTypes = {
  routes: PropTypes.array,
}

const ClientsWrapper = ({ children }) => {
  const { clientsLoading } = useContext(ClientsContext)
  if (clientsLoading) {
    return <LinearProgress />
  } else {
    return children
  }
}

ClientsWrapper.propTypes = {
  children: PropTypes.node,
}

export default Clients
